export function FlashBanner({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}): JSX.Element {
  return (
    <div className="flash-banner" role="status">
      <span>{message}</span>
      <button type="button" className="flash-dismiss" onClick={onDismiss} aria-label="Cerrar aviso">
        ×
      </button>
    </div>
  );
}
